<template>
  <el-container class="up-main">
      <el-aside width="211px">
          <left-menu :active="1"></left-menu>
      </el-aside>
      <el-main class="u-main">
        <el-form ref="form" :model="form" label-width="120px" label-position="left" :rules="rules">
          <el-form-item class="w-70" label="存证方" prop="userName">
            <el-input v-model="form.userName" disabled placeholder="请输入存证方"></el-input>
          </el-form-item>
          <el-form-item label="公告编号" prop="code">
            <el-input v-model="form.code" placeholder="请输入公告编号" onkeyup="value=value.replace(/[^\x00-\xff]/g, '')"/>
          </el-form-item>
          <el-form-item label="存证标题" prop="title">
            <el-input v-model="form.title" placeholder="请输入存证名称" />
          </el-form-item>
          <el-form-item label="业务场景" prop="sceneType">
            <el-select v-model="form.sceneType" placeholder="请选择业务场景" style="width: 100%">
              <el-option
                v-for="dict in sceneOptions"
                :key="dict.dictValue"
                :label="dict.dictLabel"
                :value="dict.dictValue"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户来源" prop="source">
            <el-select v-model="form.source" placeholder="请选择客户来源" style="width: 100%">
              <el-option
                v-for="dict in sourceOptions"
                :key="dict.dictValue"
                :label="dict.dictLabel"
                :value="dict.dictValue"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="信披平台" prop="platform">
            <el-select v-model="form.platform" placeholder="请选择信披平台" style="width: 100%">
              <el-option
                v-for="dict in platformOptions"
                :key="dict.dictValue"
                :label="dict.dictLabel"
                :value="dict.dictValue"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="公告链接" prop="noticeUrl">
            <el-input v-model="form.noticeUrl" placeholder="请输入公告链接" />
          </el-form-item>
          <el-form-item label="存证简述" prop="remark">
            <el-input type="textarea" rows="4" v-model="form.remark" :maxlength="500" placeholder="请输入内容简述" />
          </el-form-item>
          <el-form-item label="存证文件" prop="fileUrl" :rules="[{required:true,message:'请上传',trigger:'change'}]">
            <el-upload
                class="upload-part"
                :limit="1"
                :action="action"
                :headers = "headers"
                :before-upload="beforeUpload"
                :on-remove="handleRemove"
                :on-success="upload" 
                :file-list="fileList">
                <el-button size="small" type="blue">上传</el-button>
                <span style="font-size: 10px; color: #999999;margin-left: 10px;">文件大小不超过50M</span>
            </el-upload>
          </el-form-item>
        </el-form>
        <div class="cenrer">
          <el-button class="s-but" type="blue" @click="submitForm" :loading="butLoading">提 交</el-button>
        </div>
      </el-main>
  </el-container>
</template>

<script>
import leftMenu from './components/leftMenu'
import baseUrl from '@/api/baseUrl.js' 
export default {
  name: "addNotice",
  components: {
    leftMenu
  },
  data() {
    return {
      // 表单参数
      form: {},
      // 表单校验
      rules: {
        userName: [
          { required: true, message: "请输入", trigger: "blur" }
        ],
        code: [
          { required: true, message: "请输入", trigger: "blur" }
        ],
        title: [
          { required: true, message: "请输入", trigger: "blur" }
        ],
        sceneType: [
          { required: true, message: "请选择", trigger: "change" }
        ],
        source: [
          { required: true, message: "请输入", trigger: "blur" }
        ],
        platform: [
          { required: true, message: "请选择", trigger: "change" }
        ],
        noticeUrl:[
            {
              required: false,
              pattern:  /[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+\.?/,
              message: "请输入正确的网址",
              trigger: "blur"
            },
        ],
        remark: [
          { required: true, message: "请输入", trigger: "blur" }
        ],
      },
      headers: {},     
      action: '',
      file: '',
      description: '',
      butLoading: false,
      fileList: [],
      memberFormVisible: false,
      filters: {},
      dataList: [],
      listLoading: false,
      currentRow: {},
      radioId: null,
      evidenceId: null,
      sceneOptions: [
        {
          dictLabel: "拍卖文物",
          dictValue: "01"
        },
        {
          dictLabel: "拍卖不良资产",
          dictValue: "02"
        },
        {
          dictLabel: "国有产权交易",
          dictValue: "03"
        },
        {
          dictLabel: "不良金融资产",
          dictValue: "04"
        },
        {
          dictLabel: "PPP资产交易",
          dictValue: "05"
        },
        {
          dictLabel: "破产清算",
          dictValue: "06"
        },
        {
          dictLabel: "政府采购",
          dictValue: "07"
        }
      ],
      platformOptions: [
        {
          dictLabel: "中国发展网",
          dictValue: "01"
        }
      ],
      sourceOptions: [
        {
          dictLabel: "北京拍卖行业协会",
          dictValue: "01"
        },
        {
          dictLabel: "北京天珒拍卖有限公司",
          dictValue: "02"
        },
        {
          dictLabel: "天津金融资产交易所",
          dictValue: "03"
        }
      ],
      account: sessionStorage.account,
    }
  },
  created() {
    this.action = `${baseUrl.newucUrl}/iacc-notice/arbitrate/uploadArbitrationApplicationNew`;
    this.getInf() 
  },
  // computed: {
  //   newArr : function() {
  //     return JSON.parse(JSON.stringify(this.form))
  //   }
  // },
  // watch: {
  //   newArr: {
  //     handler: function(val, oldval){
  //       if (this.getAddRow() > 15) {
  //       this.form.remark = oldval.remark
  //       this.$message({
  //         message: '存证简述最多输入15行',
  //         type: 'warning'
  //       });
  //     }
  //     },
  //     deep: true
  //   },
  // },
  methods: {
    // getAddRow() {
    //   let row = 0
    //   this.form.remark.split("\n").forEach(item => {
    //       if (item.length === 0) {
    //           row += 1
    //       } else {
    //           row += Math.ceil(item.replace(/[\u0391-\uFFE5]/g,"aa").length / 20)
    //       }
    //   })
    //   return row
    // },
    getInf(){
      this.$api.api.getInfoByAccount({account: this.account}).then(response => {
        this.form.userId = response.data.account
        this.form.creatorName = response.data.companyCn
        this.form.creator = response.data.account
        this.$set(this.form, 'userName', response.data.companyCn)
      });
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.butLoading = true;
          this.form.sourceTag = 'zssj'
          this.$api.api.saveNotice(JSON.stringify(this.form)).then(response => {
            if(response.code == 200){
              this.butLoading = false;
              this.$message.success("提交成功");
              this.$router.go(-1);
            }else {
              this.$message.error(response.msg);
            }            
          });
        }
      })  
    },
    handleError(err, file, fileList){
      this.$message.error(file.name + "文件上传失败");
    },
    upload(response, file, list){
        if(response.code == 200){
          this.form.fileName = file.name
          this.form.fileHash = response.data.hash
          this.$set(this.form, 'fileUrl', response.data.path)
        }else{
            this.$message.error(file.name + "文件上传失败");
            this.form.fileName = ''
            this.form.fileHash = ''
            this.form.fileUrl = ''
            this.fileList = []
        }              
    },
    handleRemove(file, fileList) {
      this.form.fileName = ''
      this.form.fileHash = ''
      this.form.fileUrl = ''
      this.fileList = []
    },
    beforeUpload(file) { 	
      const isLt2M = file.size / 1024 / 1024 <= 50     //这里做文件大小限制
      
      if(!isLt2M) {
        this.$message.error('上传文件大小不能超过 50MB！');
      }
      return isLt2M
    },
  }
}
</script>

<style lang="less">
@import '../style.less';
</style>
